export default __webpack_public_path__ + "static/media/EM1700.34I-39959_-23770_0.40661d34.jpg";